const TotalValues = ({ totalValues, colorMap, isDesktop, isTablet, strokeColor }: any) => {
  const { title, contentTitle, contentSubhead, totalDescription } = totalValues;

  const totalValueMargin = () => {
    if (isDesktop) {
      return 24;
    } else if (isTablet) {
      return 24;
    }
    return 20;
  };
  return (
    <div style={{ marginTop: totalValueMargin(), color: strokeColor }}>
      <div className="h5 semibold">{title}</div>
      <div style={{ display: !isDesktop ? 'flex' : 'block', alignItems: 'baseline', gap: 50 }}>
        <div>
          <div className="h5 semibold">
            {contentTitle}
          </div>
          <div className="p2 semibold">
            {contentSubhead}
          </div>
        </div>
        <div style={{ display: !isDesktop ? 'flex' : 'block', gap: 40 }}>
          {totalDescription?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                style={{
                  color: colorMap[index] && colorMap[index].rgb,
                  paddingTop: '1.6rem',
                }}
              >
                <div className="h6 semibold">
                  {item.valueTitle}
                </div>
                <div className="p3 semibold">
                  {item.valueSubhead}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TotalValues;
